import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/main.css'


import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, faUsers, faLineChart, faListCheck, faDiceD20, faTimes, faBars, faCaretDown, faCaretRight, faLinkSlash, faCircleCheck, faMoon, faSun, faComments, faPaperPlane, faTrash, faRobot, faLink, faSmile, faExpand, faCompress } from '@fortawesome/free-solid-svg-icons'
library.add(faUser, faUsers, faLineChart, faListCheck, faDiceD20, faTimes, faBars, faCaretDown, faCaretRight, faLinkSlash, faCircleCheck, faMoon, faSun, faComments, faPaperPlane, faTrash, faRobot, faLink, faSmile, faExpand, faCompress)


createApp(App)
 .component('font-awesome-icon', FontAwesomeIcon)
  .use(router)
  .mount('#app')

